<nb-layout>
  @if (layoutService.showHeader()) {
    <nb-layout-header fixed>
      <ngx-header></ngx-header>
    </nb-layout-header>
  }
  
  @if (layoutService.showSidebar()) {
    <nb-sidebar>
      <ngx-sidebar></ngx-sidebar>
    </nb-sidebar>
  }
  <nb-layout-column>
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
    <router-outlet></router-outlet>
    }
  </nb-layout-column>
  @if (layoutService.showFooter()) {
    <nb-layout-footer>
      <ngx-footer></ngx-footer>
    </nb-layout-footer>
  }
</nb-layout>
